import * as React from 'react'
import Layout from '../components/Layout/Layout'
import '../index.sass'
import { Link, StaticQuery, graphql } from 'gatsby'

import compressionIcon from '../images/compression-icon.svg'
import upscaleIcon from '../images/upscale-icon.svg'
import enhanceIcon from '../images/enhance-icon.svg'
import arrowIcon from '../images/arrow-icon.svg'
import network from '../images/network.svg'
import networkMobile from '../images/network-mobile.svg'

import logoUnitedNations from '../images/logos/unitedNations.svg'
import logoGovernmentCanada from '../images/logos/governmentCanada.svg'

import logoMixtiles from '../images/logos/mixtiles.svg'
import logoSc from '../images/logos/sc.svg'
import logoTcBig from '../images/logos/tc-big.svg'
import logoTs from '../images/logos/techstars.svg'
import logoResearch from '../images/logos/research.svg'
import logoNvidia from '../images/logos/nvidia.svg'
import logoTNWNew from '../images/logos/tnw-new.svg'
import logoOodls from '../images/logos/oodls.svg'

import logoApi from '../images/logo-api.svg'
import logoCloud from '../images/logo-cloud.svg'
import logoNetwork from '../images/logo-network.svg'
import MainComparator from '../components/MainComparatorWrapper/MainComparator'
import UserCases from '../components/UserCases/UserCases'

const LandingPage: React.SFC<{}> = (props): JSX.Element => (
  <Layout footer={true}>
    <div className="main-screen">
      <MainComparator />
    </div>

    <div className="gradient-main">
      <StaticQuery
        query={queryHowItWorks}
        render={data => {
          const gullImage = {
            desktop: data.imgGull.childImageSharp.fixed,
            tablet: data.imgGullTablet.childImageSharp.fixed,
            mobile: data.imgGullMob.childImageSharp.fixed,
          }

          const gullImageZoomed = {
            desktop: data.imgGullZoomed.childImageSharp.fixed,
            tablet: data.imgGullZoomedTablet.childImageSharp.fixed,
            mobile: data.imgGullZoomedMob.childImageSharp.fixed,
          }

          const inputImgProps = data.imgHowItWorksInput.childImageSharp.fixed
          const inputImgPropsMobile =
            data.imgHowItWorksInputMobile.childImageSharp.fixed
          const inputImgPropsTablet =
            data.imgHowItWorksInputTablet.childImageSharp.fixed
          const outputImgProps = data.imgHowItWorksOutput.childImageSharp.fixed
          const outputImgPropsMobile =
            data.imgHowItWorksOutputMobile.childImageSharp.fixed
          const outputImgPropsTablet =
            data.imgHowItWorksOutputTablet.childImageSharp.fixed

          return (
            <React.Fragment>
              <section className="content">
                <h2 className="text-with-gradient title-used-by">
                  Used by
                </h2>
                <div className="used-by">
                  <a
                    href="https://blog.letsenhance.io/all/2019/11/20/be-the-change-lets-enhance-to-support-the-united-nations/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <object data={logoUnitedNations} type="image/svg+xml" />
                  </a>
                  <a
                    href="https://www.canada.ca/en/veterans-affairs-canada/news/2019/06/government-of-canada-marks-the-75th-anniversary-of-d-day-and-the-battle-of-normandy.html"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <object data={logoGovernmentCanada} type="image/svg+xml" />
                  </a>
                  {/*<a*/}
                  {/*  href="https://thenextweb.com/apps/2017/11/07/this-site-uses-machine-learning-to-enhance-your-low-res-photos-for-free"*/}
                  {/*  target="_blank"*/}
                  {/*  rel="noreferrer"*/}
                  {/*>*/}
                  <span>
                    <object data={logoOodls} type="image/svg+xml" />
                  </span>
                  {/*</a>*/}
                  <a
                    href="https://www.mixtiles.com/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <object data={logoMixtiles} type="image/svg+xml" />
                  </a>
                  <a
                    href="https://www.shimmercat.com/blog/letsenhance.html"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <object data={logoSc} type="image/svg+xml" />
                  </a>
                </div>
              </section>

              <div className="section-how-it-works">
                <section className="content">
                  <header>
                    <h1 className="text-with-gradient title-section section-how-it-works-title">
                      Our API brings you the ability to upgrade your images to
                      super-resolution. Let’s enhance it!
                    </h1>
                  </header>
                  <p>
                    Other photo editors upscale images just by stretching and
                    blurring them to cover up the all the pixelization. This
                    approach is useless to a compressed image with its missed
                    parts of information.
                  </p>

                  <div className="how-it-works-separator" />

                  <div>
                    <h2 className="subtitle">
                      We add new details and restore features of image by
                      reconstructing it from scratch
                    </h2>

                    <div className="process-example">
                      <div className="process-example-image-wrap">
                        <picture>
                          <source
                            media="(min-width: 376px)"
                            srcSet={inputImgProps.srcSet}
                            sizes={inputImgProps.sizes}
                          />
                          <source
                            media="(min-width: 375px) and (max-width : 768px)"
                            srcSet={inputImgPropsTablet.srcSet}
                            sizes={inputImgPropsTablet.sizes}
                          />
                          <source
                            media="(max-width: 375px)"
                            srcSet={inputImgPropsMobile.srcSet}
                            sizes={inputImgPropsMobile.sizes}
                          />
                          <img
                            src={inputImgProps.src}
                            alt="How it works"
                            title="How it works"
                          />
                        </picture>

                        <div className="process-example-image-data">
                          <div className="process-example-image-dim">
                            600 x 800
                          </div>
                          <div className="process-example-image-dpi">
                            72 DPI
                          </div>
                        </div>

                        <span className="process-example-image-label">
                          Your image
                        </span>
                      </div>

                      <object
                        className="arrow-icon"
                        data={arrowIcon}
                        type="image/svg+xml"
                      />

                      <div className="process-example-description">
                        <div className="process-example-title">API</div>

                        <div className="process-example-horizontal-divider" />

                        <div className="process-example-sub">
                          <div className="process-example-sub-item">
                            <object
                              data={compressionIcon}
                              type="image/svg+xml"
                            />
                            <span>
                              Compression <br /> artifacts removal
                            </span>
                          </div>

                          <div className="process-example-vertical-divider" />

                          <div className="process-example-sub-item">
                            <object data={upscaleIcon} type="image/svg+xml" />
                            <span>from x2 up to x16 upscale</span>
                          </div>

                          <div className="process-example-vertical-divider" />

                          <div className="process-example-sub-item">
                            <object data={enhanceIcon} type="image/svg+xml" />
                            <span>Color enhance</span>
                          </div>
                        </div>
                      </div>

                      <object
                        className="arrow-icon"
                        data={arrowIcon}
                        type="image/svg+xml"
                      />

                      <div className="process-example-image-wrap">
                        <picture>
                          <source
                            media="(min-width: 768px)"
                            srcSet={outputImgProps.srcSet}
                            sizes={outputImgProps.sizes}
                          />
                          <source
                            media="(min-width: 375px) and (max-width : 768px)"
                            srcSet={outputImgPropsTablet.srcSet}
                            sizes={outputImgPropsTablet.sizes}
                          />
                          <source
                            media="(max-width: 375px)"
                            srcSet={outputImgPropsMobile.srcSet}
                            sizes={outputImgPropsMobile.sizes}
                          />
                          <img
                            src={outputImgProps.src}
                            alt="How it works"
                            title="How it works"
                          />
                        </picture>

                        <div className="process-example-image-data">
                          <div className="process-example-image-dim">
                            2400 x 3200
                          </div>
                          <div className="process-example-image-dpi">
                            300 DPI
                          </div>
                        </div>

                        <span className="process-example-image-label text-with-gradient">
                          Result
                        </span>
                      </div>
                    </div>
                  </div>
                </section>

                <div className="section-hard-work-wrapper">
                <section className="content section-hard-work">
                  <header>
                    <h1 className="text-with-gradient title-section">
                      Leave hard work to us
                    </h1>
                  </header>

                  <div className="articles">
                    <article>
                      <header className="header-with-icon">
                        <img src={logoNetwork} alt="" />
                        <h2>State of Art Neural networks</h2>
                      </header>
                      <p>
                        Our research team works to build neural networks in a way to get
                        the most pleasant results for a human eye
                      </p>
                    </article>

                    <article>
                      <header className="header-with-icon">
                        <img src={logoCloud} alt="" />
                        <h2>Cloud solution</h2>
                      </header>
                      <p>
                        We are a cloud-based solution, so you can easily integrate us
                        with your existing infrastructure. Amazon S3, GCS and HTTP image
                        sources are supported from the box
                      </p>
                    </article>

                    <article>
                      <header className="header-with-icon">
                        <img src={logoApi} alt="" />
                        <h2>Flexible API</h2>
                      </header>
                      <p>
                        The API is flexible and easy to use - just define your data
                        sources, processing pipeline and watch how images are getting
                        better.
                      </p>
                    </article>
                  </div>
                </section>
              </div>
              </div>

            </React.Fragment>
          )
        }}
      />

      <UserCases />

      <div className="section-another-cases">
        <span className="section-another-cases-title">
          If you have any other cases
        </span>

        <Link
          to="/apply"
          className="btn btn-with-text btn-with-gradient gradient-full btn-learn-more"
        >
          Let us know
        </Link>
      </div>

      <div className="section-neural-network">
        <picture>
          <source media="(min-width: 415px)" srcSet={network} />
          <source media="(max-width: 415px)" srcSet={networkMobile} />
          <img src={network} />
        </picture>

        <div className="neural-network-info">
          <div className="neural-network-info-item">
            <span className="neural-network-info-title text-with-gradient">
              1.5M users
            </span>
            <span className="neural-network-info-text">
              Loved by people around the globe
            </span>
          </div>

          <div className="neural-network-info-item">
            <span className="neural-network-info-title text-with-gradient">
              10M images
            </span>
            <span className="neural-network-info-text">Improved per month</span>
          </div>

          <div className="neural-network-info-item">
            <span className="neural-network-info-title text-with-gradient">
              Trusted
            </span>
            <span className="neural-network-info-text">
              By leading printing companies and photo stocks
            </span>
          </div>

          <div className="neural-network-info-item">
            <span className="neural-network-info-title text-with-gradient">
              Backed by the best
            </span>
            <div className="neural-network-info-logos">
              <object
                className="logo-nvidia"
                data={logoNvidia}
                type="image/svg+xml"
              />
              <object
                className="logo-research"
                data={logoResearch}
                type="image/svg+xml"
              />
              <object className="logo-ts" data={logoTs} type="image/svg+xml" />
            </div>
          </div>

          <div className="neural-network-info-item">
            <span className="neural-network-info-title text-with-gradient">
              Mentions by top rated media
            </span>
            <div className="neural-network-info-logos">
              <object
                className="logo-tc-big"
                data={logoTcBig}
                type="image/svg+xml"
              />
              <object
                className="logo-tnw"
                data={logoTNWNew}
                type="image/svg+xml"
              />
            </div>
          </div>
        </div>
      </div>

      <div className="section-feedback">
        <section className="content">
          <div className="section-feedback-card">
            <div className="section-feedback-card-inner">
              <a
                href="https://mashable.com/2017/11/03/lets-enhance-photo-ai/"
                target="_blank"
                rel="noreferrer"
              >
                <object data={logoOodls} type="image/svg+xml" />
              </a>
              <span>
                “One of the challenges of working with social media content is that not all images are professionally
                shot on a camera. Brands and businesses also want to tap into user-generated content shot by everyday
                people like you and me, and we were finding that this meant the end use for those images was restricted
                because they were a bit small. By using Let’s Enhance we’re able to provide high res content that can
                be used in print.”
              </span>
            </div>
          </div>
        </section>
      </div>

      <div className="section-request-access-wrapper">
        <section className="content section-request-access">
          <p className="quote">
            Make sure every image gets the right resolution, whether you are
            looking to increase DPI for printing or get rid of pixelized images
            on your website.{' '}
          </p>
          <p>
            No matter your choice of development stack, we provide you with
            sample code snippets and guidance to integrate in minutes.
          </p>

          <div className="btn-submit-container">
            <Link
              to="/apply"
              className="btn btn-with-text btn-with-gradient gradient-full btn-learn-more"
            >
              Request Access
            </Link>
            <Link
              to="/demo"
              className="btn btn-with-text btn-with-gradient btn-learn-more  btn-transparent-content btn-learn-more-bottom"
            >
              Check the Demo
            </Link>
          </div>
        </section>
      </div>
    </div>
  </Layout>
)

const queryHowItWorks = graphql`
  query {
    imgHowItWorksInput: file(relativePath: { eq: "how-it-works-input.png" }) {
      childImageSharp {
        fixed(quality: 90) {
          ...GatsbyImageSharpFixed_withWebp
        }
      }
    }
    imgHowItWorksInputMobile: file(
      relativePath: { eq: "how-it-works-input-mobile.png" }
    ) {
      childImageSharp {
        fixed(quality: 90) {
          ...GatsbyImageSharpFixed_withWebp
        }
      }
    }
    imgHowItWorksInputTablet: file(
      relativePath: { eq: "how-it-works-input.png" }
    ) {
      childImageSharp {
        fixed(quality: 90) {
          ...GatsbyImageSharpFixed_withWebp
        }
      }
    }
    imgHowItWorksOutput: file(relativePath: { eq: "how-it-works-output.png" }) {
      childImageSharp {
        fixed(quality: 90) {
          ...GatsbyImageSharpFixed_withWebp
        }
      }
    }
    imgHowItWorksOutputMobile: file(
      relativePath: { eq: "how-it-works-output-mobile.png" }
    ) {
      childImageSharp {
        fixed(quality: 90) {
          ...GatsbyImageSharpFixed_withWebp
        }
      }
    }
    imgHowItWorksOutputTablet: file(
      relativePath: { eq: "how-it-works-output.png" }
    ) {
      childImageSharp {
        fixed(width: 224, quality: 90) {
          ...GatsbyImageSharpFixed_withWebp
        }
      }
    }
    imgGull: file(relativePath: { eq: "info-image.png" }) {
      childImageSharp {
        fixed(width: 339, quality: 90) {
          ...GatsbyImageSharpFixed_withWebp
        }
      }
    }
    imgGullTablet: file(relativePath: { eq: "info-image.png" }) {
      childImageSharp {
        fixed(width: 265, quality: 90) {
          ...GatsbyImageSharpFixed_withWebp
        }
      }
    }
    imgGullMob: file(relativePath: { eq: "info-image.png" }) {
      childImageSharp {
        fixed(width: 245, quality: 90) {
          ...GatsbyImageSharpFixed_withWebp
        }
      }
    }
    imgGullZoomed: file(relativePath: { eq: "info-image-zoomed.png" }) {
      childImageSharp {
        fixed(width: 208, quality: 90) {
          ...GatsbyImageSharpFixed_withWebp
        }
      }
    }
    imgGullZoomedTablet: file(relativePath: { eq: "info-image-zoomed.png" }) {
      childImageSharp {
        fixed(width: 125, quality: 90) {
          ...GatsbyImageSharpFixed_withWebp
        }
      }
    }
    imgGullZoomedMob: file(relativePath: { eq: "info-image-zoomed.png" }) {
      childImageSharp {
        fixed(width: 115, quality: 90) {
          ...GatsbyImageSharpFixed_withWebp
        }
      }
    }
  }
`

export default LandingPage
